import { css, SerializedStyles } from '@emotion/react';
import { AlertNoticeColor } from '../../theming';

// Static styles
export const STATIC_STYLES: SerializedStyles = css`
    // Fixed colors
    --an-color-success-icon: var(--hc-color-system-success-base);
    --an-color-success-icon-bg: var(--hc-color-system-success-tint-100);
    --an-color-error-icon: var(--hc-color-system-error-base);
    --an-color-error-icon-bg: var(--hc-color-system-error-tint-100);
    --an-color-info-icon: var(--hc-color-system-info-base);
    --an-color-info-icon-bg: var(--hc-color-system-info-tint-100);
    --an-color-warning-icon: var(--hc-color-system-warning-base);
    --an-color-warning-icon-bg: var(--hc-color-system-warning-tint-100);

    --an-radius: 12px;
    --an-graphic-size: 32px;
    --an-graphic-radius: var(--hc-radius-s);
    --an-icon-size: 24px;
    --an-padding: calc(var(--hc-spacing-unit) * 3);
    --an-font-size: 16px;

    --an-border-width: 1px;
    --an-border-color: var(--hc-color-primary-base);
    --an-close-icon-size: 16px;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--hc-spacing-unit) * 3);
    border-radius: var(--an-radius);
    color: var(--an-color);
    background-color: var(--hc-color-background-content);
    border: solid var(--an-border-width) var(--an-border-color);
    padding: var(--an-padding);
    box-shadow: var(--hc-shadow-s);

    > [data-content] {
        flex-grow: 1;
        font-size: 0.875rem;
    }

    > [data-graphic] {
        flex-shrink: 0;
        width: var(--an-graphic-size);
        height: var(--an-graphic-size);
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--an-icon-bg-color);
        border-radius: var(--an-graphic-radius);

        > [data-icon] {
            width: var(--an-icon-size);
            height: var(--an-icon-size);
            display: inline-block;
            fill: var(--an-icon-color);
        }
    }

    // [data-close-button] {
    //     align-self: flex-start;
    // }
`;

export function useDynamicStyles(color: AlertNoticeColor): React.CSSProperties {
    return {
        '--an-icon-color': `var(--an-color-${color}-icon)`,
        '--an-icon-bg-color': `var(--an-color-${color}-icon-bg)`,
    } as React.CSSProperties;
}
